<div class="thumb-bg-img">
  <img [src]="imageSrc" alt="Image" />
  <span class="text">{{slideText}}</span>
</div>
